import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Welcome from './pages/Welcome';
import LandingPage from './pages/LandingPage';
import LoginAdmin from './pages/LoginAdmin';
import Dashboard from './pages/Dashboard';
import CadastroCrianca from './pages/CadastroCrianca';
import ListaParticipantes from './pages/ListaParticipantes';
import PerfilCrianca from './pages/PerfilCrianca';
import LancamentoDiario from './pages/LancamentoDiario';
import LancamentoSemanal from './pages/LancamentoSemanal';
import LancarSementesExtras from './pages/LancarSementesExtras';
import Pontuacao from './pages/Pontuacao';
import Ranking from './pages/Ranking';
import Relatorios from './pages/Relatorios';
import Configuracoes from './pages/Configuracoes';
import LoginPais from './pages/parent/LoginPais';
import DashboardPais from './pages/parent/DashboardPais';
import LancamentoPais from './pages/parent/LancamentoPais';
import CadastroViaConvite from './pages/parent/CadastroViaConvite';
import CadastroPais from './pages/parent/CadastroPais';
import EditarPerfilFamilia from './pages/parent/EditarPerfilFamilia';
import CompartilharApp from './pages/CompartilharApp';
import LogsEdicao from './pages/LogsEdicao';
import PerfilAdmin from './pages/PerfilAdmin';
import AlterarSenha from './pages/AlterarSenha';
import CadastroVoluntario from './pages/CadastroVoluntario';
import ListaVoluntarios from './pages/ListaVoluntarios';
import GruposDiscipulado from './pages/GruposDiscipulado';
import RelatorioWhatsApp from './pages/RelatorioWhatsApp';
import FaleConosco from './pages/FaleConosco';
import ListaFeedback from './pages/ListaFeedback';
import BackupRestore from './pages/BackupRestore';
import AgendaMinisterio from './pages/AgendaMinisterio';
import EscalaTrabalho from './pages/EscalaTrabalho';
import ManualAjuda from './pages/ManualAjuda';
import GestaoUsuarios from './pages/GestaoUsuarios';
import CheckinPais from './pages/CheckinPais';
import CheckinVoluntario from './pages/CheckinVoluntario';
import EncontroAoVivo from './pages/EncontroAoVivo';
import GestaoPais from './pages/GestaoPais';
import GestaoAreas from './pages/GestaoAreas';
import EditarLandingPage from './pages/EditarLandingPage';
import AdminWhatsApp from './pages/AdminWhatsApp';
import EstacaoImpressao from './pages/EstacaoImpressao';
import RecuperarSenha from './pages/RecuperarSenha';
import DataTransfer from './pages/DataTransfer';
import PedidosOracao from './pages/PedidosOracao';
import QRCodeVoluntarios from './pages/QRCodeVoluntarios';
import CadastroVoluntarioPublico from './pages/CadastroVoluntarioPublico';
import Mensalidades from './pages/Mensalidades';
import InstalarApp from './pages/InstalarApp';
import RelatorioGrupos from './pages/RelatorioGrupos';
import RelatorioExecutivo from './pages/RelatorioExecutivo';
import Aniversariantes from './pages/Aniversariantes';
import PrivateRoute from './components/PrivateRoute';
import { Toaster } from 'sonner';
import './App.css';

function App() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/login" element={<LoginAdmin />} />
          <Route path="/recuperar-senha" element={<RecuperarSenha />} />
          
          {/* Rotas Administrativas Protegidas */}
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/cadastro" element={<PrivateRoute adminOnly><CadastroCrianca /></PrivateRoute>} />
          <Route path="/participantes" element={<PrivateRoute><ListaParticipantes /></PrivateRoute>} />
          <Route path="/participante/:id" element={<PrivateRoute><PerfilCrianca /></PrivateRoute>} />
          <Route path="/lancamento/diario" element={<PrivateRoute><LancamentoDiario /></PrivateRoute>} />
          <Route path="/lancamento/semanal" element={<PrivateRoute><LancamentoSemanal /></PrivateRoute>} />
          <Route path="/sementes-extras" element={<PrivateRoute adminOnly><LancarSementesExtras /></PrivateRoute>} />
          <Route path="/pontuacao" element={<PrivateRoute><Pontuacao /></PrivateRoute>} />
          <Route path="/ranking" element={<PrivateRoute><Ranking /></PrivateRoute>} />
          <Route path="/relatorios" element={<PrivateRoute><Relatorios /></PrivateRoute>} />
          <Route path="/configuracoes" element={<PrivateRoute><Configuracoes /></PrivateRoute>} />
          <Route path="/perfil-admin" element={<PrivateRoute><PerfilAdmin /></PrivateRoute>} />
          <Route path="/compartilhar" element={<PrivateRoute><CompartilharApp /></PrivateRoute>} />
          <Route path="/usuarios" element={<PrivateRoute adminOnly><GestaoUsuarios /></PrivateRoute>} />
          <Route path="/checkin" element={<PrivateRoute adminOnly><CheckinVoluntario /></PrivateRoute>} />
          <Route path="/relatorio-whatsapp" element={<PrivateRoute adminOnly><RelatorioWhatsApp /></PrivateRoute>} />
          <Route path="/encontro-ao-vivo" element={<PrivateRoute adminOnly><EncontroAoVivo /></PrivateRoute>} />
          <Route path="/checkin-pais" element={<CheckinPais />} />
          <Route path="/logs" element={<PrivateRoute adminOnly><LogsEdicao /></PrivateRoute>} />
          <Route path="/alterar-senha" element={<PrivateRoute><AlterarSenha userType="admin" /></PrivateRoute>} />
          <Route path="/voluntarios" element={<PrivateRoute><ListaVoluntarios /></PrivateRoute>} />
          <Route path="/voluntarios/cadastro" element={<PrivateRoute><CadastroVoluntario /></PrivateRoute>} />
          <Route path="/grupos" element={<PrivateRoute><GruposDiscipulado /></PrivateRoute>} />
          <Route path="/relatorio-grupos" element={<PrivateRoute><RelatorioGrupos /></PrivateRoute>} />
          <Route path="/relatorio-executivo" element={<PrivateRoute><RelatorioExecutivo /></PrivateRoute>} />
          <Route path="/aniversariantes" element={<PrivateRoute><Aniversariantes /></PrivateRoute>} />
          <Route path="/fale-conosco" element={<FaleConosco />} />
          <Route path="/feedback" element={<PrivateRoute><ListaFeedback /></PrivateRoute>} />
          <Route path="/backups" element={<PrivateRoute adminOnly><BackupRestore /></PrivateRoute>} />
          <Route path="/agenda" element={<PrivateRoute><AgendaMinisterio /></PrivateRoute>} />
          <Route path="/escalas" element={<PrivateRoute><EscalaTrabalho /></PrivateRoute>} />
          <Route path="/ajuda" element={<ManualAjuda />} />
          <Route path="/dados" element={<PrivateRoute adminOnly><DataTransfer /></PrivateRoute>} />
          <Route path="/oracoes" element={<PedidosOracao />} />
          <Route path="/qrcode-voluntarios" element={<PrivateRoute adminOnly><QRCodeVoluntarios /></PrivateRoute>} />
          <Route path="/gestao-pais" element={<PrivateRoute adminOnly><GestaoPais /></PrivateRoute>} />
          <Route path="/gestao-areas" element={<PrivateRoute adminOnly><GestaoAreas /></PrivateRoute>} />
          <Route path="/editar-landing" element={<PrivateRoute adminOnly><EditarLandingPage /></PrivateRoute>} />
          <Route path="/admin/whatsapp" element={<PrivateRoute adminOnly><AdminWhatsApp /></PrivateRoute>} />
          <Route path="/checkin/impressora" element={<PrivateRoute adminOnly><EstacaoImpressao /></PrivateRoute>} />
          <Route path="/mensalidades" element={<PrivateRoute><Mensalidades /></PrivateRoute>} />
          <Route path="/cadastro-voluntario-publico" element={<CadastroVoluntarioPublico />} />
          <Route path="/instalar" element={<InstalarApp />} />
          
          {/* Rotas do App dos Pais */}
          <Route path="/app-pais/login" element={<LoginPais />} />
          <Route path="/app-pais/cadastro" element={<CadastroPais />} />
          <Route path="/app-pais/convite/:token" element={<CadastroViaConvite />} />
          <Route path="/app-pais/dashboard" element={<DashboardPais />} />
          <Route path="/app-pais/lancamento" element={<LancamentoPais />} />
          <Route path="/app-pais/editar-perfil" element={<EditarPerfilFamilia />} />
          <Route path="/app-pais/alterar-senha" element={<AlterarSenha userType="parent" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
